import { useDispatch, useSelector } from 'react-redux';
import { menuData } from '../constant/menuData';
import { NavLink } from 'react-router-dom';
import { logout } from '../redux/slice/authSlice';
import { RootState } from '../redux/store';



const Sidebar = () => {


  const dispatch = useDispatch();

  const role = useSelector((state: RootState) => state?.auth?.user?.user?.role);

  if(!role) {
    dispatch(logout())
  }


  const handleLogout = async () => {
    dispatch(logout())
  }
  

  return (
  
    <aside className='w-[50px] lg:w-[260px] h-[calc(100vh-85px)] border-r-[1px] flex flex-col top-[85px] left-0 sticky'>
      <div className="px-1 py-6">
        {menuData
          .filter((item) => item.visible.includes(role))
          .map((item) => (
          <NavLink
            to={item.url}
            key={item.name}
            className={({ isActive }) =>
              `flex items-center text-[#000] font-[500] gap-2 p-2 lg:p-3 rounded-full mt-2 ${
                isActive ? "text-[#fff] bg-[#016AFF]" : ""
              }`
            }
          >
            {({ isActive }) => (
                <>
                  <img
                    src={item.icon}
                    alt=""
                    className={`md:ml-[10px] ${isActive ? "icon-white" : ""}`}
                  />
                  <span className="hidden lg:block text-sm">{item.name}</span>
                </>
              )}    
          </NavLink>
          ))}
    </div>

    {/* BOTTOM */}
      <div className="mt-auto mb-[20px] border-t-[1px] flex items-center px-3 py-6 gap-3 cursor-pointer" onClick={handleLogout}>
        <img src='/logout.svg' alt="" className="md:ml-[10px]" />
        <span className='hidden lg:block text-sm'>Log Out</span>
      </div>
    </aside>
  )
}

export default Sidebar;
